import { Route, Routes } from "react-router-dom";
import OrganizationReset from "./OrganizationReset";

const OrganizationResetIndex = () => {
  return (
    <Routes>
      <Route path="" element={<OrganizationReset />} />
    </Routes>
  );
};

export default OrganizationResetIndex;
